export enum SciencePageId {
  SCIENCE = 'science_v2_why_mitopure',
  HOW_IT_WORKS = 'howItWorks',
  BENEFITS = 'benefits_page',
  BENEFITS_SKINCARE = 'skincare_benefits_page',
  STUDIES = 'studies',
  PATENTS = 'patents',
}
